import React from 'react'
import injectSheet from 'react-jss'
import icecream from 'pobble-components/dist/no-items-placeholder/icelolly.png'
import octopus from 'pobble-components/dist/no-items-placeholder/octopus.png'
import candy from 'pobble-components/dist/no-items-placeholder/candy.png'
import classNames from 'classnames'

const styles = ({ COLORS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    flex: '1',
    '& img': {
      width: '17.2em',
      height: 'auto',
      objectFit: 'contain',
      marginBottom: '2em'
    },
    '& p': {
      margin: '0',
      textAlign: 'center'
    },
    '& a': {
      color: COLORS.BLUE.NORMAL,
      cursor: 'pointer',
      fontWeight: 'bold',
      textDecoration: 'none'
    }
  }
})

const NoItemsPlaceholder = ({
  classes,
  children,
  className,
  illustration = 'octopus'
}) => {
  return (
    <div className={classNames(classes.container, className)}>
      {illustration === 'octopus' && (
        <img src={octopus} alt="Octopus" widt="700" height="700" />
      )}
      {illustration === 'icecream' && (
        <img src={icecream} alt="Ice cream" width="350" height="350" />
      )}
      {illustration === 'candy' && (
        <img src={candy} alt="Candy" width="350" height="229" />
      )}
      {children}
    </div>
  )
}

export default injectSheet(styles)(NoItemsPlaceholder)
